export const CSVMIMETYPE = 'text/csv';
export const PDFMIMETYPE = 'application/pdf';

export const ADMINUSERFILENAME = 'admin_user_report';
export const UTILIZATIONFILENAME = 'utilization_report';
